module.exports = __webpack_public_path__ + "img/gallery-image-24.602dc52c.jpg";